import React, { useEffect, useState } from "react";
import Footer from "../../components/Footer/footer";
import Navbar from "../../components/Navbar/Navbar";
import Workspace from "../../components/Workspace/Workspace";
import MyDesktopsBar, {
  useMyDesktopsBarVisible,
} from "../../components/MyDesktopsBar/MyDesktopsBar";
import NativeFavoritesMenu from "~/desktop/NativeFavoritesMenu";
import DesktopAuthBridge from "~/desktop/DesktopAuthBridge";
import { useThemeStore } from "~/store/themeStore";
import { isDarkTheme } from "~/config/themes";
import "./main.css";

const Main = () => {
  const initializeTheme = useThemeStore((state) => state.initializeTheme);
  const theme = useThemeStore((state) => state.theme);
  const [themeReady, setThemeReady] = useState(false);
  const myDesktopsBarVisible = useMyDesktopsBarVisible();

  useEffect(() => {
    // Initialize theme when Main component mounts
    initializeTheme();

    // Force reapply body class immediately
    const isDark = isDarkTheme(theme);
    console.log("[Main] Applying theme immediately:", {
      theme,
      isDark,
      bodyClasses: document.body.className,
    });

    if (isDark) {
      document.body.classList.add("dark-mode-custom");
    } else {
      document.body.classList.remove("dark-mode-custom");
    }

    console.log(
      "[Main] Body classes after initial apply:",
      document.body.className,
    );

    // Wait for theme CSS to load and then trigger re-render
    const timer = setTimeout(() => {
      console.log("[Main] Theme loaded, forcing re-render.");
      // Force body class again
      if (isDark) {
        document.body.classList.add("dark-mode-custom");
      } else {
        document.body.classList.remove("dark-mode-custom");
      }
      console.log("[Main] Final body classes:", document.body.className);
      setThemeReady(true);
    }, 150);

    return () => clearTimeout(timer);
  }, [initializeTheme, theme]);

  return (
    <div
      className={`main-container${myDesktopsBarVisible ? " has-my-desktops-bar" : ""}`}
      key={themeReady ? "ready" : "loading"}
    >
      {myDesktopsBarVisible && (
        <div className="my-desktops-bar-container">
          <MyDesktopsBar />
        </div>
      )}

      {/* App desktop: mesma feature, superfície nativa. Headless — no web
          não monta nada (o próprio componente checa isDesktopApp). */}
      <NativeFavoritesMenu />
      <DesktopAuthBridge />

      <div className="navbar-container">
        <Navbar />
      </div>

      <div className="workspace-container">
        <Workspace />
      </div>

      <div className="footer-container">
        <Footer />
      </div>
    </div>
  );
};

export default Main;
